import { render, staticRenderFns } from "./MyBenefitFeature.vue?vue&type=template&id=7de44704"
import script from "./MyBenefitFeature.vue?vue&type=script&lang=js"
export * from "./MyBenefitFeature.vue?vue&type=script&lang=js"
import style0 from "./MyBenefitFeature.vue?vue&type=style&index=0&id=7de44704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports